import {
    useEffect,
    useState
} from 'react';

const usePublicationSubscribePopup = (
    salesforceID: string | undefined,
    isPublicationCustomer: boolean,
    isSubscribePath: boolean = false
) => {
    const [
        shouldShow,
        setShouldShow
    ] = useState(false);

    const storageKey = salesforceID ? `${salesforceID}-popup-shown` : null;

    useEffect(() => {
        if (!salesforceID || !isPublicationCustomer || isSubscribePath) {
            setShouldShow(false);

            return;
        }

        const hasSeen = storageKey ? localStorage.getItem(storageKey) === 'true' : false;

        if (!hasSeen) {
            setShouldShow(true);
        }
    }, [
        salesforceID,
        isPublicationCustomer,
        storageKey,
        isSubscribePath
    ]);

    const hide = () => {
        if (storageKey) {
            localStorage.setItem(storageKey, 'true');
        }

        setShouldShow(false);
    };

    return {
        hide,
        shouldShow
    };
};

export default usePublicationSubscribePopup;
